import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import check from "../../assets/images/icons8-check-48.png";
import { NullBadgeUrl } from "../../tools/utils";
import { t } from "i18next";
import { messageMap } from "../../utils/messageMap";

export const BulkUpdateTable = () => {
  const { bulkUpdateList } = useSelector(
    (state: RootState) => state.bulkUpload
  );

  return (
    <div
      className="cco_list_view_wrapper"
      style={{
        width: "100%",
        overflowX: "auto",
        // overflowY: loading ? "hidden" : "auto", //  Block scroll when loading
        maxHeight: "500px",
        border: "1px solid #ddd",
        borderRadius: "8px",
        backgroundColor: "#fff",
        position: "relative",
        scrollbarColor: "#c67b05 #f5f5f5",
      }}
    >
      {/* Scrollbar Styling */}
      <style>
        {`
          .cco_list_view_wrapper::-webkit-scrollbar {
            width: 8px;
            height: 8px;
          }
          .cco_list_view_wrapper::-webkit-scrollbar-track {
            background: #f5f5f5;
            border-radius: 10px;
          }
          .cco_list_view_wrapper::-webkit-scrollbar-thumb {
            background-color: #c67b05;
            border-radius: 10px;
          }
          .cco_list_view_wrapper::-webkit-scrollbar-thumb:hover {
            background-color: #a56303;
          }
          .cco_list_view_wrapper::-webkit-scrollbar-button {
            display: none;
            height: 0;
            width: 0;
          }
          @supports (scrollbar-width: thin) {
            .cco_list_view_wrapper {
              scrollbar-width: thin;
              scrollbar-color: #c67b05 #f5f5f5;
            }
          }
        `}
      </style>

      {/* 🔸 Table */}
      <table
        style={{
          width: "100%",
          minWidth: "700px",
          fontFamily: "Arial, sans-serif",
          borderCollapse: "collapse",

        }}
      >
        <thead>
          <tr>
            {[
    t("bulkUpload.Name"),
    t("bulkUpload.ccoId"),
    t("bulkUpload.EligibleToConnect")
  ].map((header, i) => (
              <th
                key={i}
                style={{
                  textAlign: i === 2 ? "center" : "left",
                  backgroundColor: "#c67b05",
                  color: "#fff",
                  padding: "10px 14px",
                  position: "sticky",
                  top: 0,
                  zIndex: 5,
                  boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                  whiteSpace: "nowrap",
                }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>

          {bulkUpdateList.map((connection, index) => (
            <tr
              key={index}
              style={{
                backgroundColor: "#fff",
                transition: "background 0.2s ease",
                borderBottom: "1px solid #eee",
              }}
            >
              <td
                style={{
                  padding: "6px 12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  fontWeight: 600,
                  verticalAlign: "middle",
                }}
              >
                <span style={{ fontSize: "12px" }}>{index + 1}</span>
                <img
                  src={connection.myccoProfile || NullBadgeUrl}
                  alt={connection.Name}
                  style={{
                    width: "25px",
                    height: "25px",
                    objectFit: "cover",
                    borderRadius: "6px",
                    border: connection.myccoProfile
                      ? "none"
                      : "1px solid rgb(0 0 0 / 10%)",
                  }}
                />
                <span style={{ fontSize: "12px", color: "#222", lineHeight: 1 }}>
                  {connection.Name}
                </span>
              </td>

              <td
                style={{
                  padding: "8px 12px",
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#333",
                  whiteSpace: "nowrap",
                }}
              >
                {connection.CCOID || "---"}
              </td>

              <td
                style={{
                  padding: "8px 12px",
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#333",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
              >
                {connection.Iscreated ? (
                  <>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" ,justifyContent:"center"}}>
                      <img
                        src={check}
                        alt="Available"
                        style={{ width: "25px", height: "25px" }}
                      />
                      <p
                        style={{
                          color: "green",
                          fontSize: "12px",
                          fontWeight: "bold",
                          margin: 0,
                        }}
                      >
                        {connection.Message?.map((message, i) => {
      const translationKey = messageMap[message] || message; // fallback to original
      return (
        <span key={i}>{t(translationKey)}</span>
      );
    }) || t("bulkUpload.success")}
                      </p>
                    </div>

                  </>
                ) : connection.Eligible ? (
                  <img
                    src={check}
                    alt="Available"
                    style={{ width: "25px", height: "25px" }}
                  />
                ) : (
                  connection.Message?.map((message, i) => {
  const translationKey = messageMap[message] || message; // fallback to original if not found

  return (
    <p
      key={i}
      style={{
        color: "red",
        fontSize: "12px",
        fontWeight: "bold",
        margin: 0,
      }}
    >
      {t(translationKey)}
    </p>
  );
})
)
                }
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* 🔸 Overlay Loader
      {(loading || requestLoading) && (
        <div
          style={{
            position: "sticky",
            inset: 0,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
            borderRadius: "8px",
            width: "100%",
            height: "100%",
          }}
        >
          <div
            style={{
              border: "4px solid #f3f3f3",
              borderTop: "4px solid #c67b05",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              animation: "spin 1s linear infinite",
            }}
          ></div>

          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
          </style>
        </div>
      )} */}
    </div>
  );
};
